import ThankYouRegister from 'components/tailgrids-ui/thank-you/register';
import React from 'react';

export default function ThankYouRegistrationTastic({ data }) {
  return <ThankYouRegister {...data} />;
}
